import { render } from "./create.vue?vue&type=template&id=fdc73e72&scoped=true"
import script from "./create.vue?vue&type=script&lang=js"
export * from "./create.vue?vue&type=script&lang=js"

import "./create.vue?vue&type=style&index=0&id=fdc73e72&scoped=true&lang=css"

import exportComponent from "/var/www/kim-new-moover/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fdc73e72"]])

export default __exports__